var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGa = function SvgGa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    d: "M640 480H0V0h640z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36a100",
    d: "M640 160.003H0V0h640z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006dbc",
    d: "M640 480H0V319.997h640z"
  }))));
};
export default __webpack_public_path__ + "assets/3bccb26524d04e3abb3dc4fa8b5047df.svg";
export { SvgGa as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ga.svg